(() => {
  if (customElements.get('sedr-pdp-free-shipping')) return;
  customElements.define('sedr-pdp-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.variantEligible = this.getAttribute('variant-eligible') !== 'false';
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('cart:change', (event) => this.update(event.detail?.cart), options);
      document.addEventListener('cart:refresh', () => this.load(), options);
      this.closest('.shopify-section')?.addEventListener('variant:change', (event) => {
        // The theme's input[name="id"] can shadow form.id in the event detail.
        const formId = event.target?.tagName === 'FORM' ? event.target.getAttribute('id') : event.detail?.formId;
        if (formId !== this.getAttribute('form-id')) return;
        const variant = event.detail?.variant;
        this.variantEligible = Boolean(variant?.requires_shipping && variant.available);
        if (!this.variantEligible) { this.hidden = true; return; }
        this.setAttribute('variant-price', variant.price);
        this.load();
      }, options);
      if (this.variantEligible) this.load();
      else this.hidden = true;
    }
    disconnectedCallback() {
      this.version = (this.version || 0) + 1;
      this.controller.abort();
      this.requestController?.abort();
    }
    async load() {
      const version = this.version = (this.version || 0) + 1;
      this.requestController?.abort();
      const controller = this.requestController = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal: controller.signal });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (this.isConnected && this.version === version) this.update(cart);
      } catch { if (this.version === version) this.hidden = true; }
      finally { clearTimeout(timer); }
    }
    update(cart) {
      this.version = (this.version || 0) + 1;
      if (!this.variantEligible || this.getAttribute('country') !== 'SA' || cart?.currency !== 'SAR' || window.Shopify?.currency?.active !== 'SAR' || !Array.isArray(cart.items)) { this.hidden = true; return; }
      const threshold = Number(this.getAttribute('threshold'));
      const price = Number(this.getAttribute('variant-price'));
      const validAmount = amount => Number.isSafeInteger(amount) && amount >= 0;
      const discounts = cart.cart_level_discount_applications || [];
      if (!validAmount(threshold) || threshold === 0 || !validAmount(price) || !Array.isArray(discounts) || discounts.some(d => !validAmount(d?.total_allocated_amount)) || cart.items.some(i => !i || typeof i.requires_shipping !== 'boolean' || (i.requires_shipping && !validAmount(i.final_line_price)))) { this.hidden = true; return; }
      const discount = discounts.reduce((sum, d) => sum + d.total_allocated_amount, 0);
      const subtotal = cart.items.filter(i => i.requires_shipping).reduce((sum, i) => sum + i.final_line_price, 0);
      if (!validAmount(subtotal) || !validAmount(discount)) { this.hidden = true; return; }
      const total = Math.max(0, subtotal - discount);
      const remaining = Math.max(0, threshold - total);
      const en = this.hasAttribute('en');
      const money = n => `${new Intl.NumberFormat('en', { maximumFractionDigits: 2 }).format(n / 100)} ${en ? 'SAR' : 'ر.س.'}`;
      const thresholdLabel = this.querySelector('[data-threshold-label]');
      if (thresholdLabel) thresholdLabel.textContent = en
        ? `On orders of ${money(threshold)} or more`
        : `للطلبات من ${money(threshold)}`;
      // Only formatted numeric amounts and fixed copy enter the markup.
      // One unit of this product covers the remaining amount: say so plainly instead of "X to go".
      const single = remaining > 0 && price >= remaining;
      this.querySelector('[data-message]').innerHTML = single
        ? (en ? 'This product qualifies you for free shipping' : 'هذا المنتج يؤهلك للشحن المجاني')
        : remaining
        ? (en ? `<bdi class="sedr-ship-amount">${money(remaining)}</bdi> to go` : `باقي <bdi class="sedr-ship-amount">${money(remaining)}</bdi>`)
        : (en ? 'Your cart has reached the threshold' : 'بلغت سلتك الحد المطلوب');
      this.toggleAttribute?.('reached', remaining === 0);
      const count = remaining && price > 0 && !single ? Math.ceil(remaining / price) : 0;
      const quantity = count === 1 ? 'حبة واحدة' : count === 2 ? 'حبتين' : `${count} ${count <= 10 ? 'حبات' : 'حبة'}`;
      this.querySelector('[data-addition]').innerHTML = count
        ? (en ? `Add <strong class="sedr-ship-quantity">${count} ${count === 1 ? 'item' : 'items'}</strong> of the selected size` : `أضف <strong class="sedr-ship-quantity">${quantity}</strong> من الحجم المختار`) : '';
      const note = this.querySelector('[data-note]');
      if (note) note.textContent = count
        ? (en ? 'Estimated quantity; discounts may change it' : 'العدد تقديري؛ قد يتغير مع الخصومات')
        : (en ? 'Confirmed at checkout' : 'تُؤكَّد الأهلية عند الدفع');
      const progress = this.querySelector('[data-progress]');
      progress.value = Math.min(threshold, total);
      progress.setAttribute?.('aria-valuetext', en
        ? `${money(total)} of ${money(threshold)}; ${money(remaining)} remaining`
        : `${money(total)} من ${money(threshold)}؛ المتبقي ${money(remaining)}`);
      this.hidden = false;
    }
  });
})();
